import { Fragment, useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Calendar, momentLocalizer } from "react-big-calendar";
import * as moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";

import "./Dashboard.css";
import Context from "context/context";
import DashboardAPI from "apis/panel/dashboard/dashboard";

import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";

const localizer = momentLocalizer(moment);

export default function Dashboard() {
  const { state, dispatch } = useContext(Context);
  const navigate = useNavigate();

  const { getVRAScheduleAPI } = DashboardAPI();

  const [employeeSchedule, setEmployeeSchedule] = useState([]);
  const [date, setDate] = useState(new Date());
  const [view, setView] = useState("week");
  const [activeView, setActiveView] = useState("Week");

  const renderDayPropGetter = (date) => {
    const day = moment(date).day();

    const isPublicHoliday = publicHolidays.some((holiday) =>
      holiday.isSame(date, "day")
    );

    if (isPublicHoliday) {
      return {
        style: {
          backgroundColor: "#00FF0033",
          borderRadius: "20px",
          textAlign: "center",
          alignItems: "center",
        },
      };
    } else if (day === 6 || day === 0) {
      // 6 = Saturday, 0 = Sunday
      return {
        style: {
          backgroundColor: "#fff",
          textAlign: "center",
          alignItems: "center",
        },
      };
    }
    return {};
  };

  const publicHolidays = [
    moment("2024-01-01"),
    moment("2024-07-04"),
    moment("2024-12-25"),
  ];
  console.log("Logging");
  useEffect(() => {
    handleGetEmployeeScheduleAPI();
  }, [state.employee]);

  const handleGetEmployeeScheduleAPI = async () => {
    try {
      // dispatch({ type: "SET_LOADING", payload: true });
      let res = await getVRAScheduleAPI();
      let formattedData = [];
      if (res?.data?.length > 0) {
        res?.data?.map((d) => {
          formattedData = [
            ...formattedData,
            {
              ...d,
              start: new Date(d?.start),
              end: new Date(d?.end),
              // allDay: d?.assignmentType !== "Assigned with RAD" ? true : false,
            },
          ];
        });
      }
      setEmployeeSchedule(formattedData || []);
      // dispatch({ type: "SET_LOADING", payload: false });
    } catch (err) {
      // dispatch({ type: "SET_LOADING", payload: false });
    }
  };

  const CustomToolbar = ({ label, onNavigate, onView }) => {
    return (
      <div className="cal-view-nav">
        <div className="cal-view-nav-left">
          <ArrowBackIosIcon
            className="cal-view-nav-back-arrow"
            onClick={() => onNavigate("PREV")}
          />
          <ArrowForwardIosIcon
            className="cal-view-nav-forward-arrow"
            onClick={() => onNavigate("NEXT")}
          />
          <button
            className="cal-view-nav-today-btn"
            onClick={() => onNavigate("TODAY")}
          >
            Today
          </button>
        </div>
        <div className="cal-view-nav-center">
          <span>{label}</span>
        </div>
        <div className="cal-view-nav-right">
          {["Week", "Month", "Agenda"]?.map((d) => (
            <span
              className={
                d === activeView
                  ? "cal-view-nav-right-content-active"
                  : "cal-view-nav-right-content"
              }
              onClick={() => {
                onView(d?.toLocaleLowerCase());
                setActiveView(d);
              }}
            >
              {d}
            </span>
          ))}
          {/* <span className="cal-view-nav-right-content" onClick={() => onView("month")}>Month</span>
          <span className="cal-view-nav-right-content" onClick={() => onView("agenda")}>Agenda</span> */}
        </div>
      </div>
    );
  };

  // Custom event component for Month view
  const CustomEvent = ({ event }) => {
    const startTime = moment(event.start).format("hh:mm A"); // Start time
    const endTime = moment(event.end).format("hh:mm A"); // End time

    return (
      <div style={{ fontSize: "14px" }}>
        <div>{event.title}</div>{" "}
        {event?.assignmentType === "Assigned with RAD" && (
          <Fragment>
            <span>
              {startTime} - {endTime}
            </span>
          </Fragment>
        )}
      </div>
    );
  };

  // Function to assign colors based on the title
  const getEventColor = (title) => {
    switch (title) {
      case "Available VRA":
        return { backgroundColor: "#017A39", color: "#fff" };
      case "Week Off":
        return { backgroundColor: "#EC5800", color: "#fff" };
      case "Privilege Leave":
        return { backgroundColor: "#645452", color: "#fff" };
      case "Sick Leave":
        return { backgroundColor: "#392F5A", color: "#fff" };
      case "Compensatory Leave":
        return { backgroundColor: "#004385", color: "#fff" };
      case "Loss of Pay":
        return { backgroundColor: "#96031a", color: "#fff" };
      case "Maternity Leave":
        return { backgroundColor: "#db068d", color: "#fff" };
      case "Paternity Leave":
        return { backgroundColor: "#F7A399", color: "#fff" };
      case "Miscarriage":
        return { backgroundColor: "#db068d", color: "#fff" };
      case "Tubectomy":
        return { backgroundColor: "#db068d", color: "#fff" };
      case "Adoptive Mothers":
        return { backgroundColor: "#db068d", color: "#fff" };
      case "Maternity leave(1st & 2nd Child)":
        return { backgroundColor: "#db068d", color: "#fff" };
      case "Maternity leave(3+ Children)":
        return { backgroundColor: "#db068d", color: "#fff" };
      default:
        return { backgroundColor: "#1f7a8c", color: "#fff" };
    }
  };

  // Function to return custom styles for events
  const eventPropGetter = (event) => {
    const style = getEventColor(event.title);
    return { style };
  };

  const getindicatorColor = (title) => {
    switch (title) {
      case "Available VRA":
        return "#017A39";
      case "Week Off":
        return "#EC5800";
      case "Privilege Leave":
        return "#645452";
      case "Sick Leave":
        return "#392F5A";
      case "Compensatory Leave":
        return "#004385";
      case "Loss of Pay":
        return "#96031a";
      case "Maternity Leave":
        return "#db068d";
      case "Paternity Leave":
        return "#F7A399";
      case "Miscarriage":
        return "#db068d";
      case "Tubectomy":
        return "#db068d";
      case "Adoptive Mothers":
        return "#db068d";
      case "Maternity leave(1st & 2nd Child)":
        return "#db068d";
      case "Maternity leave(3+ Children)":
        return "#db068d";
      default:
        return "#1f7a8c";
    }
  };

  return (
    <Fragment>
      <div
        className="custom-calendar-close"
        onClick={() => {
          navigate("/panel/employeeInformation");
        }}
      >
        {" "}
        <CancelOutlinedIcon className="custom-calendar-close-icon" />{" "}
        <span className="custom-calendar-close-text">Close</span>
      </div>
      <div className="custom-calendar">
        <Card
          style={{
            width: "80%",
            padding: "20px",
            boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
            borderRadius: "10px",
            height: "fit-content",
          }}
        >
          <div className="custom-calendar-header">VRA Schedule Calendar</div>
          <Calendar
            date={date}
            view={view}
            onNavigate={(newDate) => {
              setDate(newDate);
            }}
            onView={(newView) => setView(newView)}
            views={["day", "week", "month", "agenda"]}
            localizer={localizer}
            events={employeeSchedule}
            // dayPropGetter={renderDayPropGetter}
            components={{
              toolbar: CustomToolbar, // Using custom toolbar
              month: {
                event: CustomEvent, // Override event rendering in Month view
              },
            }}
            startAccessor="start" // Ensure this matches your event data structure
            endAccessor="end" // Ensure this matches your event data structure
            titleAccessor="title" // Ensure this matches your event data structure
            eventPropGetter={eventPropGetter} // Apply custom styles
          />
        </Card>
        <Card
          style={{
            width: "20%",
            padding: "20px",
            boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
            borderRadius: "10px",
          }}
        >
          <div className="custom-calendar-header">Indicators</div>
          {[
            "VRA Schedule",
            "Available VRA",
            "Week Off",
            "Privilege Leave",
            "Sick Leave",
            "Compensatory Leave",
            "Loss of Pay",
            "Maternity Leave",
            "Paternity Leave",
          ]?.map((i) => (
            <div>
              <div className="indicator-div">
                <div
                  style={{ backgroundColor: getindicatorColor(i) }}
                  className="indicator-color"
                ></div>
                <div className="indicator-name">{i}</div>
              </div>
            </div>
          ))}
        </Card>
      </div>
    </Fragment>
  );
}
